// extracted by mini-css-extract-plugin
export default {"text":"input_text__0KcrW","input":"input_input__MHVyr","password_input":"input_password_input__nS6lX"};